@if (hasIcon) {
  <pc-icon [icon]="icon"></pc-icon>
}
<ng-content></ng-content>
